(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("26bsd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $187506d5b1cfb700$export$71511d61b312f219; });

var $afUn2 = parcelRequire("afUn2");

var $giCaB = parcelRequire("giCaB");

var $220cd = parcelRequire("220cd");

var $aCRvb = parcelRequire("aCRvb");
function $187506d5b1cfb700$export$71511d61b312f219(arr) {
    return (0, $afUn2._)(arr) || (0, $giCaB._)(arr) || (0, $aCRvb._)(arr) || (0, $220cd._)();
}

});
parcelRegister("afUn2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7777081c2a4b1a86$export$71511d61b312f219; });

var $IChKS = parcelRequire("IChKS");
function $7777081c2a4b1a86$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $IChKS._)(arr);
}

});
parcelRegister("IChKS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0861ceda66c08a50$export$71511d61b312f219; });
function $0861ceda66c08a50$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("giCaB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bddbef8d2db60240$export$71511d61b312f219; });
function $bddbef8d2db60240$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("220cd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $17abeb9ade6216e7$export$71511d61b312f219; });
function $17abeb9ade6216e7$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("aCRvb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7bc6f45e6716f784$export$71511d61b312f219; });

var $IChKS = parcelRequire("IChKS");
function $7bc6f45e6716f784$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $IChKS._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $IChKS._)(o, minLen);
}

});


parcelRegister("7Osso", function(module, exports) {

$parcel$export(module.exports, "aniScroll", function () { return $5b0346e2b2b2d0d6$export$1a19be9ddcc0f28a; });
/**
 * Scroll-Based Animations
 *
 * Animate elements fluidly based on scroll position.
 *
 * Examples:
 *  aniScroll('.parallax-parent');
 *  // or
 *  aniScroll(document.querySelectorAll('.parallax-parent'));
 *  // or
 *  aniScroll([
 *      document.querySelector('.parallax-parent-1'),
 *      document.querySelector('.parallax-parent-2')
 *  ]);
 *
 * @param  {mixed}    mixed     Wrapper element (as selector string, nodelist, or array of nodes)
 * @param  {boolean}  viewport  False to use full element height (defualt) or true to use viewport height
 */ var $5b0346e2b2b2d0d6$export$1a19be9ddcc0f28a = function(mixed) {
    var viewport = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // identify scroll-based animation elements
    var isStr = typeof mixed === 'string';
    var scrollWraps = isStr ? document.querySelectorAll(mixed) : mixed;
    // bail if we have nothing
    if (!scrollWraps.length) return;
    // prep to store all scroll-based animation elements
    var scrollable = {};
    // prep to store all all currently animating elements
    var scrollers = {};
    // animate things based on scroll position
    var animate = function() {
        // if we have elements that should animate (i.e. they're in the viewport)
        var keys = Object.keys(scrollers);
        if (keys.length) // animate each
        keys.forEach(function(key) {
            var item = scrollers[key];
            var win = window.innerHeight;
            var _item_getBoundingClientRect = item.getBoundingClientRect(), top = _item_getBoundingClientRect.top, height = _item_getBoundingClientRect.height;
            var per = viewport ? top / win : (top + height) / (win + height);
            // don't go out of bounds
            if (per < 0) per = 0;
            else if (per > 1) per = 1;
            scrollers[key].style.setProperty('--ani-plx', per);
        });
    };
    // create an observer so we can animate elements only when in view
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            // get the ID of this entry
            var id = entry.target.dataset.aniScroll;
            // if in view add to currently animating and identify as shown
            if (entry.isIntersecting) {
                scrollers[id] = scrollable[id];
                scrollable[id].classList.add('is-shown');
            // if not in view remove shown and delete from currently animating
            } else {
                scrollable[id].classList.remove('is-shown');
                delete scrollers[id];
            }
        });
    }, {
        rootMargin: '10px 0px 10px'
    });
    // controll scroll-based animations (throttled)
    var timer;
    window.addEventListener('scroll', function() {
        window.cancelAnimationFrame(timer);
        timer = window.requestAnimationFrame(animate);
    });
    // initialize animations
    scrollWraps.forEach(function(el, index) {
        // create a unique id for this element
        var id = "el".concat(index);
        el.dataset.aniScroll = id;
        // add this element to the list of scrollable things
        scrollable[id] = el;
        // add these to the observer so it can apply animations when they're in view
        observer.observe(el);
    });
    // trigger animations on initial script load
    animate();
    // reload on load to be certain image sizes e.g. are calculated
    window.addEventListener('load', animate);
    // reload on resize (debounced)
    var resizeTimer = null;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            animate();
        }, 300);
    });
};

});

parcelRegister("6Ywq0", function(module, exports) {

$parcel$export(module.exports, "ani", function () { return $51417e4c2c5dd199$export$54f1b784138e2127; });
$parcel$export(module.exports, "aniDelegate", function () { return $51417e4c2c5dd199$export$f8bf712d50738e; });
/**
 * Viewport-Based Animations
 *
 * Run an animation on elements once they enter the viewport.
 *
 * @param {nodelist}} els Elements to which we'll attach animations
 */ 
var $26bsd = parcelRequire("26bsd");
var $51417e4c2c5dd199$export$54f1b784138e2127 = function(els) {
    // if we have elements
    if (els.length) {
        // set up an observer
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                // toggle .is-shown based on visibility in viewport
                entry.target.classList.toggle('is-shown', entry.isIntersecting);
            });
        }, {
            rootMargin: '10px 0px 0px'
        });
        // add all elements to the observer
        els.forEach(function(el) {
            observer.observe(el);
        });
    }
};
var $51417e4c2c5dd199$export$f8bf712d50738e = function(delegatedSelectors) {
    var aniClassName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'ani';
    var allAniEls = [];
    // for every parent/child pair
    delegatedSelectors.forEach(function(param) {
        var parentSelector = param.parent, childSelector = param.child;
        var // for every parent element
        _document_querySelectorAll;
        (_document_querySelectorAll = document.querySelectorAll(parentSelector)) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function(parentEl) {
            // get all the children we're to delegate to
            var childEls = parentEl.querySelectorAll(childSelector);
            // if we have children to delegate to
            if (childEls.length) {
                var // remove ani classes from the parent
                _parentEl_classList;
                // get the parent's ani classes
                var aniClassNames = [
                    aniClassName
                ].concat((0, $26bsd._)((0, $26bsd._)(parentEl.classList).filter(function(className) {
                    return className.substr(0, 5) === "".concat(aniClassName, "--");
                })));
                // for every child we're delegating to
                childEls === null || childEls === void 0 ? void 0 : childEls.forEach(function(childEl, i) {
                    var // add ani classes
                    _childEl_classList;
                    (_childEl_classList = childEl.classList).add.apply(_childEl_classList, (0, $26bsd._)(aniClassNames));
                    // stagger animations slightly
                    childEl.style.setProperty('--ani-delay-increment', i);
                    // add this child to the animation list
                    allAniEls.push(childEl);
                });
                (_parentEl_classList = parentEl.classList).remove.apply(_parentEl_classList, (0, $26bsd._)(aniClassNames));
            } else if (parentEl.classList.contains(aniClassName)) // add parent to animation list (if has ani class and no delegates)
            allAniEls.push(parentEl);
        });
    });
    return allAniEls;
};

});

/* eslint-disable import/no-unresolved */ /**
 * Global block styling and WordPress overrides.
 */ 
var $22de3301df789697$exports = {};

$22de3301df789697$exports = {
    "CarouselControls": {}
};


var $85031724dc66c864$exports = {};
var $b8f9b3920d30cce4$exports = {};
/**
 * Ani JavaScript
 *
 * This file defines behaviors of
 * ani blocks.
 */ // import animations

var $26bsd = parcelRequire("26bsd");
/**
 * On-Load Animations
 *
 * @param {mixed} element Selector string, nodelist, or array of nodes.
 * @param {array} aniClassNameList Class names for animations (so we can remove it)
 */ 
var $26bsd = parcelRequire("26bsd");
var $3401775855c67e87$export$2eb69c0aa2ecf141 = function(element) {
    var aniClassNameList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        'ani'
    ];
    var els = typeof element === 'string' ? document.querySelectorAll(element) : element;
    if (els.length) els.forEach(function(el) {
        var // remove other animation types (like viewport-based animations)
        _el_classList;
        (_el_classList = el.classList).remove.apply(_el_classList, (0, $26bsd._)(aniClassNameList));
        // if this is a loadable media element
        if (el.complete !== undefined) {
            if (el.complete) // show the element after a bit if it's already cached
            setTimeout(function() {
                el.classList.add('is-shown');
            }, 100);
            else // show the element after it loads for the first time
            el.addEventListener('load', function() {
                el.classList.add('is-shown');
            });
        } else if ([
            'interactive',
            'complete'
        ].includes(document.readyState)) // show the element if the page is already ready
        el.classList.add('is-shown');
        else // show the element on page ready
        document.addEventListener('DOMContentLoaded', function() {
            return el.classList.add('is-shown');
        }, false);
    });
};



var $7Osso = parcelRequire("7Osso");
/**
 * Background Animations
 *
 * Full-screen, fixed-position background animations.
 *
 * @param {mixed} element Selector string, nodelist, or array of nodes.
 * @param {boolean} isPopupStyle Whether to block adjacent content like a popup on active.
 */ 
var $26bsd = parcelRequire("26bsd");
var $a6e6f3dcc3df3e37$export$a77aa55c7ffce249 = function(element) {
    var isPopupStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var els = typeof element === 'string' ? document.querySelectorAll(element) : element;
    if (els.length) {
        // watch intersection
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                // if the element is shown
                var el = entry.target;
                if (entry.isIntersecting) {
                    el.classList.add('is-shown-bg');
                    if (el === null || el === void 0 ? void 0 : el.classTransfers) el.classTransfers.forEach(function(className) {
                        el.fixedBackground.classList.add(className);
                        el.classList.add(className);
                    });
                    el.fixedBackground.classList.add('active');
                } else {
                    el.classList.remove('is-shown-bg');
                    el.fixedBackground.classList.remove('active');
                    el.classList.remove(el.colorClassName);
                }
            });
        }, {
            rootMargin: '-50% 0% -50%'
        });
        // loop through our elements
        var torsoEl = document.querySelector('.torso');
        els.forEach(function(el) {
            // create the background feature and add it to the body (behind everything else)
            var fixedBackground = document.createElement('i');
            fixedBackground.setAttribute('aria-hidden', true);
            fixedBackground.classList.add('background-color-block', "background-color-block--".concat(isPopupStyle ? 'foreground' : 'background'));
            var coverEls = el.querySelectorAll('.wp-block-cover__gradient-background, .wp-block-cover__video-background, .wp-block-cover__image-background, .wp-block-cover__background');
            if (coverEls.length) {
                fixedBackground.classList.add('wp-block-cover');
                coverEls.forEach(function(childEl) {
                    return fixedBackground.appendChild(childEl);
                });
            }
            torsoEl.appendChild(fixedBackground);
            el.fixedBackground = fixedBackground;
            // determine what classes to add/remove
            var classNames = (0, $26bsd._)(el.classList);
            var classTransfers = classNames.filter(function(className) {
                return /^has-.*-background-color$/.test(className) || /^is-style-.*$/.test(className);
            });
            if (classTransfers.length) el.classTransfers = classTransfers;
            // wait to remove background till things are loaded
            if (el.tagName.toLowerCase() === 'header') onReady(function() {
                // wait till bg animations finish
                setTimeout(function() {
                    el.classList.add('is-loaded');
                }, 1000);
            });
            // attach the observer to the animated elements
            observer.observe(el);
        });
    }
};



var $6Ywq0 = parcelRequire("6Ywq0");
// execute animations
(0, $3401775855c67e87$export$2eb69c0aa2ecf141)('.ani--load');
(0, $7Osso.aniScroll)('.ani--parallax');
(0, $a6e6f3dcc3df3e37$export$a77aa55c7ffce249)('.ani--background');
(0, $a6e6f3dcc3df3e37$export$a77aa55c7ffce249)('.ani--foreground', true);
(0, $6Ywq0.ani)((0, $26bsd._)((0, $6Ywq0.aniDelegate)([
    {
        parent: '.ani-parent',
        child: '.ani-child'
    },
    // eslint-disable-next-line prettier/prettier
    {
        parent: '.wp-block-cover:not(.ani--parallax)',
        child: '.wp-block-cover__image-background'
    },
    {
        parent: '.wp-block-columns',
        child: '.wp-block-column'
    },
    {
        parent: '.wp-block-buttons',
        child: '.wp-block-button'
    },
    {
        parent: 'ul.ani',
        child: 'li'
    }
])).concat((0, $26bsd._)(document.querySelectorAll('.ani'))));


$85031724dc66c864$exports = {
    "extended-ani": {
        "ani-": $b8f9b3920d30cce4$exports
    }
};


var $f032b8babc04d380$exports = {};







$f032b8babc04d380$exports = {
    "extended-ani": {
        "ani-": {}
    },
    "extended-backgrounds": {},
    "extended-containers": {},
    "extended-column": {
        "column-": {}
    },
    "extended-hide": {
        "hide-": {}
    },
    "extended-list": {},
    "extended-separator": {}
};



})();
//# sourceMappingURL=blocks.bundle.js.map
